export default "__VITE_ASSET__AeQFlY4e__"